import classNames from "classnames";
import { RiSearchLine } from "react-icons/ri";
import PeriodicityIcon from "../../modules/periodicity-icon/PeriodicityIcon";
import React from "react";
import { FormattedMessage } from "react-intl";

export function FavouriteSearch(props) {
  const items = props.items ?? [];
  const active = props.focusedOn === props.uniqueKey;
  const isLoading = props.isLoading;

  const getDisplayName = (item) => {
    let displayName = `${item.article_name_and_qualities} ${
      item.producer ?? ""
    }`;

    // item.availability !== "AVAILABLE_IN_CATALOG"
    if (item?.availability !== 2) {
      displayName += " // unverfügbar //";
    }

    return displayName;
  };

  return (
    <div className="search-container">
      <div className="search-container__row">
        <input
          className="search-container__box"
          type="text"
          placeholder={props.placeholder}
          onChange={(e) =>
            props.search(e.target.value.trim().toLowerCase(), props.uniqueKey)
          }
          disabled={isLoading}
        ></input>
        <div className="search-container__icon">
          <RiSearchLine size={16} color={"gray"} />
        </div>
      </div>
      <div
        className={classNames("search-container__items", {
          "search-container__active": active,
        })}
      >
        {items.length > 0 ? (
          <ul>
            {items.map((item) => (
              <li
                key={item.id || `${item.article_name_and_qualities}-${item.producer}`}
                onClick={() => props.onSelect(item)}
                className={classNames({
                  selected: item.selected,
                })}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {getDisplayName(item)} {item.unit_display}
                <PeriodicityIcon interval={"E"} editable={!item.selected} />
              </li>
            ))}
          </ul>
        ) : (
          active && (
            <div className="search-container__no-results">
              <FormattedMessage id="noSearchResults" />
            </div>
          )
        )}
      </div>
    </div>
  );
}
